import { CartErrorEvent as e, CartLinesUpdateEvent as t, StandardEvents as n } from "@shopify/events";
//#region node_modules/preact/dist/preact.module.js
var r, i, a, o, s, c, l, u, d, f, p, m, h, g, _ = {}, v = [], y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, b = Array.isArray;
function x(e, t) {
	for (var n in t) e[n] = t[n];
	return e;
}
function S(e) {
	e && e.parentNode && e.parentNode.removeChild(e);
}
function C(e, t, n) {
	var i, a, o, s = {};
	for (o in t) o == "key" ? i = t[o] : o == "ref" ? a = t[o] : s[o] = t[o];
	if (arguments.length > 2 && (s.children = arguments.length > 3 ? r.call(arguments, 2) : n), typeof e == "function" && e.defaultProps != null) for (o in e.defaultProps) s[o] === void 0 && (s[o] = e.defaultProps[o]);
	return w(e, s, i, a, null);
}
function w(e, t, n, r, o) {
	var s = {
		type: e,
		props: t,
		key: n,
		ref: r,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: o ?? ++a,
		__i: -1,
		__u: 0
	};
	return o == null && i.vnode != null && i.vnode(s), s;
}
function T(e) {
	return e.children;
}
function E(e, t) {
	this.props = e, this.context = t;
}
function D(e, t) {
	if (t == null) return e.__ ? D(e.__, e.__i + 1) : null;
	for (var n; t < e.__k.length; t++) if ((n = e.__k[t]) != null && n.__e != null) return n.__e;
	return typeof e.type == "function" ? D(e) : null;
}
function O(e) {
	if (e.__P && e.__d) {
		var t = e.__v, n = t.__e, r = [], a = [], o = x({}, t);
		o.__v = t.__v + 1, i.vnode && i.vnode(o), te(e.__P, o, t, e.__n, e.__P.namespaceURI, 32 & t.__u ? [n] : null, r, n ?? D(t), !!(32 & t.__u), a), o.__v = t.__v, o.__.__k[o.__i] = o, re(r, o, a), t.__e = t.__ = null, o.__e != n && k(o);
	}
}
function k(e) {
	if ((e = e.__) != null && e.__c != null) return e.__e = e.__c.base = null, e.__k.some(function(t) {
		if (t != null && t.__e != null) return e.__e = e.__c.base = t.__e;
	}), k(e);
}
function A(e) {
	(!e.__d && (e.__d = !0) && o.push(e) && !j.__r++ || s != i.debounceRendering) && ((s = i.debounceRendering) || c)(j);
}
function j() {
	try {
		for (var e, t = 1; o.length;) o.length > t && o.sort(l), e = o.shift(), t = o.length, O(e);
	} finally {
		o.length = j.__r = 0;
	}
}
function M(e, t, n, r, i, a, o, s, c, l, u) {
	var d, f, p, m, h, g, y = r && r.__k || v, b = t.length;
	for (c = N(n, t, y, c, b), d = 0; d < b; d++) (p = n.__k[d]) != null && (f = p.__i != -1 && y[p.__i] || _, p.__i = d, g = te(e, p, f, i, a, o, s, c, l, u), m = p.__e, p.ref && f.ref != p.ref && (f.ref && ae(f.ref, null, p), u.push(p.ref, p.__c || m, p)), h == null && m != null && (h = m), 4 & p.__u ? (c = P(p, c, e), f.__e && (f.__e = null)) : typeof p.type == "function" && g !== void 0 ? c = g : m && (c = m.nextSibling), p.__u &= -7);
	return n.__e = h, c;
}
function N(e, t, n, r, i) {
	var a, o, s, c, l, u = n.length, d = u, f = 0;
	for (e.__k = Array(i), a = 0; a < i; a++) (o = t[a]) != null && typeof o != "boolean" && typeof o != "function" ? (typeof o == "string" || typeof o == "number" || typeof o == "bigint" || o.constructor == String ? o = e.__k[a] = w(null, o, null, null, null) : b(o) ? o = e.__k[a] = w(T, { children: o }, null, null, null) : o.constructor === void 0 && o.__b > 0 ? o = e.__k[a] = w(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : e.__k[a] = o, c = a + f, o.__ = e, o.__b = e.__b + 1, s = null, (l = o.__i = F(o, n, c, d)) != -1 && (d--, (s = n[l]) && (s.__u |= 2)), s == null || s.__v == null ? (l == -1 && (i > u ? f-- : i < u && f++), typeof o.type != "function" && (o.__u |= 4)) : l != c && (l == c - 1 ? f-- : l == c + 1 ? f++ : (l > c ? f-- : f++, o.__u |= 4))) : e.__k[a] = null;
	if (d) for (a = 0; a < u; a++) (s = n[a]) != null && !(2 & s.__u) && (s.__e == r && (r = D(s)), oe(s, s));
	return r;
}
function P(e, t, n) {
	var r, i;
	if (typeof e.type == "function") {
		for (r = e.__k, i = 0; r && i < r.length; i++) r[i] && (r[i].__ = e, t = P(r[i], t, n));
		return t;
	}
	e.__e != t && (t && e.type && !t.parentNode && (t = D(e)), t = n.insertBefore(e.__e, t || null));
	do
		t &&= t.nextSibling;
	while (t != null && t.nodeType == 8);
	return t;
}
function F(e, t, n, r) {
	var i, a, o, s = e.key, c = e.type, l = t[n], u = l != null && !(2 & l.__u);
	if (l === null && s == null || u && s == l.key && c == l.type) return n;
	if (r > +!!u) {
		for (i = n - 1, a = n + 1; i >= 0 || a < t.length;) if ((l = t[o = i >= 0 ? i-- : a++]) != null && !(2 & l.__u) && s == l.key && c == l.type) return o;
	}
	return -1;
}
function ee(e, t, n) {
	t[0] == "-" ? e.setProperty(t, n ?? "") : e[t] = n == null ? "" : typeof n != "number" || y.test(t) ? n : n + "px";
}
function I(e, t, n, r, i) {
	var a, o;
	n: if (t == "style") {
		if (typeof n == "string") e.style.cssText = n;
		else {
			if (typeof r == "string" && (e.style.cssText = r = ""), r) for (t in r) n && t in n || ee(e.style, t, "");
			if (n) for (t in n) r && n[t] == r[t] || ee(e.style, t, n[t]);
		}
	} else if (t[0] == "o" && t[1] == "n") a = t != (t = t.replace(p, "$1")), o = t.toLowerCase(), t = o in e || t == "onFocusOut" || t == "onFocusIn" ? o.slice(2) : t.slice(2), e.l ||= {}, e.l[t + a] = n, n ? r ? n[f] = r[f] : (n[f] = m, e.addEventListener(t, a ? g : h, a)) : e.removeEventListener(t, a ? g : h, a);
	else {
		if (i == "http://www.w3.org/2000/svg") t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
		else if (t != "width" && t != "height" && t != "href" && t != "list" && t != "form" && t != "tabIndex" && t != "download" && t != "rowSpan" && t != "colSpan" && t != "role" && t != "popover" && t in e) try {
			e[t] = n ?? "";
			break n;
		} catch {}
		typeof n == "function" || (n == null || !1 === n && t[4] != "-" ? e.removeAttribute(t) : e.setAttribute(t, t == "popover" && n == 1 ? "" : n));
	}
}
function L(e) {
	return function(t) {
		if (this.l) {
			var n = this.l[t.type + e];
			if (t[d] == null) t[d] = m++;
			else if (t[d] < n[f]) return;
			return n(i.event ? i.event(t) : t);
		}
	};
}
function te(e, t, n, r, a, o, s, c, l, u) {
	var d, f, p, m, h, g, _, y, C, w, O, k, A, j, N, P, F = t.type;
	if (t.constructor !== void 0) return null;
	128 & n.__u && (l = !!(32 & n.__u), o = [c = t.__e = n.__e]), (d = i.__b) && d(t);
	n: if (typeof F == "function") {
		f = s.length;
		try {
			if (C = t.props, w = F.prototype && F.prototype.render, O = (d = F.contextType) && r[d.__c], k = d ? O ? O.props.value : d.__ : r, n.__c ? y = (p = t.__c = n.__c).__ = p.__E : (w ? t.__c = p = new F(C, k) : (t.__c = p = new E(C, k), p.constructor = F, p.render = se), O && O.sub(p), p.state || (p.state = {}), p.__n = r, m = p.__d = !0, p.__h = [], p._sb = []), w && p.__s == null && (p.__s = p.state), w && F.getDerivedStateFromProps != null && (p.__s == p.state && (p.__s = x({}, p.__s)), x(p.__s, F.getDerivedStateFromProps(C, p.__s))), h = p.props, g = p.state, p.__v = t, m) w && F.getDerivedStateFromProps == null && p.componentWillMount != null && p.componentWillMount(), w && p.componentDidMount != null && p.__h.push(p.componentDidMount);
			else {
				if (w && F.getDerivedStateFromProps == null && C !== h && p.componentWillReceiveProps != null && p.componentWillReceiveProps(C, k), t.__v == n.__v || !p.__e && p.shouldComponentUpdate != null && !1 === p.shouldComponentUpdate(C, p.__s, k)) {
					t.__v != n.__v && (p.props = C, p.state = p.__s, p.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.some(function(e) {
						e && (e.__ = t);
					}), v.push.apply(p.__h, p._sb), p._sb = [], p.__h.length && s.push(p), c = D(n);
					break n;
				}
				p.componentWillUpdate != null && p.componentWillUpdate(C, p.__s, k), w && p.componentDidUpdate != null && p.__h.push(function() {
					p.componentDidUpdate(h, g, _);
				});
			}
			if (p.context = k, p.props = C, p.__P = e, p.__e = !1, A = i.__r, j = 0, w) p.state = p.__s, p.__d = !1, A && A(t), d = p.render(p.props, p.state, p.context), v.push.apply(p.__h, p._sb), p._sb = [];
			else do
				p.__d = !1, A && A(t), d = p.render(p.props, p.state, p.context), p.state = p.__s;
			while (p.__d && ++j < 25);
			p.state = p.__s, p.getChildContext != null && (r = x(x({}, r), p.getChildContext())), w && !m && p.getSnapshotBeforeUpdate != null && (_ = p.getSnapshotBeforeUpdate(h, g)), N = d != null && d.type === T && d.key == null ? R(d.props.children) : d, c = M(e, b(N) ? N : [N], t, n, r, a, o, s, c, l, u), p.base = t.__e, t.__u &= -161, p.__h.length && s.push(p), y && (p.__E = p.__ = null);
		} catch (e) {
			if (s.length = f, t.__v = null, l || o != null) {
				if (e.then) {
					for (t.__u |= l ? 160 : 128; c && c.nodeType == 8 && c.nextSibling;) c = c.nextSibling;
					o != null && (o[o.indexOf(c)] = null), t.__e = c;
				} else if (o != null) for (P = o.length; P--;) S(o[P]);
			} else t.__e = n.__e;
			t.__k ??= n.__k || [], e.then || ne(t), i.__e(e, t, n);
		}
	} else o == null && t.__v == n.__v ? (t.__k = n.__k, t.__e = n.__e) : c = t.__e = ie(n.__e, t, n, r, a, o, s, l, u);
	return (d = i.diffed) && d(t), 128 & t.__u ? void 0 : c;
}
function ne(e) {
	e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(ne));
}
function re(e, t, n) {
	for (var r = 0; r < n.length; r++) ae(n[r], n[++r], n[++r]);
	i.__c && i.__c(t, e), e.some(function(t) {
		try {
			e = t.__h, t.__h = [], e.some(function(e) {
				e.call(t);
			});
		} catch (e) {
			i.__e(e, t.__v);
		}
	});
}
function R(e) {
	return typeof e != "object" || !e || e.__b > 0 ? e : b(e) ? e.map(R) : e.constructor === void 0 ? x({}, e) : null;
}
function ie(e, t, n, a, o, s, c, l, u) {
	var d, f, p, m, h, g, v, y = n.props || _, x = t.props, C = t.type;
	if (C == "svg" ? o = "http://www.w3.org/2000/svg" : C == "math" ? o = "http://www.w3.org/1998/Math/MathML" : o ||= "http://www.w3.org/1999/xhtml", s != null) {
		for (d = 0; d < s.length; d++) if ((h = s[d]) && "setAttribute" in h == !!C && (C ? h.localName == C : h.nodeType == 3)) {
			e = h, s[d] = null;
			break;
		}
	}
	if (e == null) {
		if (C == null) return document.createTextNode(x);
		e = document.createElementNS(o, C, x.is && x), l &&= (i.__m && i.__m(t, s), !1), s = null;
	}
	if (C == null) y === x || l && e.data == x || (e.data = x);
	else {
		if (s = C == "textarea" && x.defaultValue != null ? null : s && r.call(e.childNodes), !l && s != null) for (y = {}, d = 0; d < e.attributes.length; d++) y[(h = e.attributes[d]).name] = h.value;
		for (d in y) h = y[d], d == "dangerouslySetInnerHTML" ? p = h : d == "children" || d in x || d == "value" && "defaultValue" in x || d == "checked" && "defaultChecked" in x || I(e, d, null, h, o);
		for (d in x) h = x[d], d == "children" ? m = h : d == "dangerouslySetInnerHTML" ? f = h : d == "value" ? g = h : d == "checked" ? v = h : l && typeof h != "function" || y[d] === h || I(e, d, h, y[d], o);
		if (f) l || p && (f.__html == p.__html || f.__html == e.innerHTML) || (e.innerHTML = f.__html), t.__k = [];
		else if (p && (e.innerHTML = ""), M(t.type == "template" ? e.content : e, b(m) ? m : [m], t, n, a, C == "foreignObject" ? "http://www.w3.org/1999/xhtml" : o, s, c, s ? s[0] : n.__k && D(n, 0), l, u), s != null) for (d = s.length; d--;) S(s[d]);
		l && C != "textarea" || (d = "value", C == "progress" && g == null ? e.removeAttribute("value") : g != null && (g !== e[d] || C == "progress" && !g || C == "option" && g != y[d]) && I(e, d, g, y[d], o), d = "checked", v != null && v != e[d] && I(e, d, v, y[d], o));
	}
	return e;
}
function ae(e, t, n) {
	try {
		if (typeof e == "function") {
			var r = typeof e.__u == "function";
			r && e.__u(), r && t == null || (e.__u = e(t));
		} else e.current = t;
	} catch (e) {
		i.__e(e, n);
	}
}
function oe(e, t, n) {
	var r, a;
	if (i.unmount && i.unmount(e), (r = e.ref) && (r.current && r.current != e.__e || ae(r, null, t)), (r = e.__c) != null) {
		if (r.componentWillUnmount) try {
			r.componentWillUnmount();
		} catch (e) {
			i.__e(e, t);
		}
		r.base = r.__P = r.__n = null;
	}
	if (r = e.__k) for (a = 0; a < r.length; a++) r[a] && oe(r[a], t, n || typeof e.type != "function");
	n || S(e.__e), e.__c = e.__ = e.__e = void 0;
}
function se(e, t, n) {
	return this.constructor(e, n);
}
function ce(e, t, n) {
	var a, o, s, c;
	t == document && (t = document.documentElement), i.__ && i.__(e, t), o = (a = typeof n == "function") ? null : n && n.__k || t.__k, s = [], c = [], te(t, e = (!a && n || t).__k = C(T, null, [e]), o || _, _, t.namespaceURI, !a && n ? [n] : o ? null : t.firstChild ? r.call(t.childNodes) : null, s, !a && n ? n : o ? o.__e : t.firstChild, a, c), re(s, e, c), e.props.children = null;
}
r = v.slice, i = { __e: function(e, t, n, r) {
	for (var i, a, o; t = t.__;) if ((i = t.__c) && !i.__) try {
		if ((a = i.constructor) && a.getDerivedStateFromError != null && (i.setState(a.getDerivedStateFromError(e)), o = i.__d), i.componentDidCatch != null && (i.componentDidCatch(e, r || {}), o = i.__d), o) return i.__E = i;
	} catch (t) {
		e = t;
	}
	throw e;
} }, a = 0, E.prototype.setState = function(e, t) {
	var n = this.__s != null && this.__s != this.state ? this.__s : this.__s = x({}, this.state);
	typeof e == "function" && (e = e(x({}, n), this.props)), e && x(n, e), e != null && this.__v && (t && this._sb.push(t), A(this));
}, E.prototype.forceUpdate = function(e) {
	this.__v && (this.__e = !0, e && this.__h.push(e), A(this));
}, E.prototype.render = T, o = [], c = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, l = function(e, t) {
	return e.__v.__b - t.__v.__b;
}, j.__r = 0, u = Math.random().toString(8), d = "__d" + u, f = "__a" + u, p = /(PointerCapture)$|Capture$/i, m = 0, h = L(!1), g = L(!0);
//#endregion
//#region node_modules/preact/hooks/dist/hooks.module.js
var z, B, V, le, H = 0, ue = [], U = i, de = U.__b, fe = U.__r, pe = U.diffed, me = U.__c, he = U.unmount, ge = U.__;
function _e(e, t) {
	U.__h && U.__h(B, e, H || t), H = 0;
	var n = B.__H || (B.__H = {
		__: [],
		__h: []
	});
	return e >= n.__.length && n.__.push({}), n.__[e];
}
function W(e) {
	return H = 1, ve(Ee, e);
}
function ve(e, t, n) {
	var r = _e(z++, 2);
	if (r.t = e, !r.__c && (r.__ = [n ? n(t) : Ee(void 0, t), function(e) {
		var t = r.__N ? r.__N[0] : r.__[0], n = r.t(t, e);
		t !== n && (r.__N = [n, r.__[1]], r.__c.setState({}));
	}], r.__c = B, !B.__f)) {
		var i = function(e, t, n) {
			if (!r.__c.__H) return !0;
			var i = !1, o = r.__c.props !== e;
			if (r.__c.__H.__.some(function(e) {
				if (e.__N) {
					i = !0;
					var t = e.__[0];
					e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (o = !0);
				}
			}), a) {
				var s = a.call(this, e, t, n);
				return i ? s || o : s;
			}
			return !i || o;
		};
		B.__f = !0;
		var a = B.shouldComponentUpdate, o = B.componentWillUpdate;
		B.componentWillUpdate = function(e, t, n) {
			if (this.__e) {
				var r = a;
				a = void 0, i(e, t, n), a = r;
			}
			o && o.call(this, e, t, n);
		}, B.shouldComponentUpdate = i;
	}
	return r.__N || r.__;
}
function G(e, t) {
	var n = _e(z++, 3);
	!U.__s && Te(n.__H, t) && (n.__ = e, n.u = t, B.__H.__h.push(n));
}
function K(e) {
	return H = 5, q(function() {
		return { current: e };
	}, []);
}
function q(e, t) {
	var n = _e(z++, 7);
	return Te(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
}
function ye(e, t) {
	return H = 8, q(function() {
		return e;
	}, t);
}
function be() {
	for (var e; e = ue.shift();) {
		var t = e.__H;
		if (e.__P && t) try {
			t.__h.some(Ce), t.__h.some(we), t.__h = [];
		} catch (n) {
			t.__h = [], U.__e(n, e.__v);
		}
	}
}
U.__b = function(e) {
	B = null, de && de(e);
}, U.__ = function(e, t) {
	e && t.__k && t.__k.__m && (e.__m = t.__k.__m), ge && ge(e, t);
}, U.__r = function(e) {
	fe && fe(e), z = 0;
	var t = (B = e.__c).__H;
	t && (V === B ? (t.__h = [], B.__h = [], t.__.some(function(e) {
		e.__N && (e.__ = e.__N), e.u = e.__N = void 0;
	})) : (t.__h.some(Ce), t.__h.some(we), t.__h = [], z = 0)), V = B;
}, U.diffed = function(e) {
	pe && pe(e);
	var t = e.__c;
	t && t.__H && (t.__H.__h.length && (ue.push(t) !== 1 && le === U.requestAnimationFrame || ((le = U.requestAnimationFrame) || Se)(be)), t.__H.__.some(function(e) {
		e.u &&= (e.__H = e.u, void 0);
	})), V = B = null;
}, U.__c = function(e, t) {
	t.some(function(e) {
		try {
			e.__h.some(Ce), e.__h = e.__h.filter(function(e) {
				return !e.__ || we(e);
			});
		} catch (n) {
			t.some(function(e) {
				e.__h &&= [];
			}), t = [], U.__e(n, e.__v);
		}
	}), me && me(e, t);
}, U.unmount = function(e) {
	he && he(e);
	var t, n = e.__c;
	n && n.__H && (n.__H.__.some(function(e) {
		try {
			Ce(e);
		} catch (e) {
			t = e;
		}
	}), n.__H = void 0, t && U.__e(t, n.__v));
};
var xe = typeof requestAnimationFrame == "function";
function Se(e) {
	var t, n = function() {
		clearTimeout(r), xe && cancelAnimationFrame(t), setTimeout(e);
	}, r = setTimeout(n, 35);
	xe && (t = requestAnimationFrame(n));
}
function Ce(e) {
	var t = B, n = e.__c;
	typeof n == "function" && (e.__c = void 0, n()), B = t;
}
function we(e) {
	var t = B;
	e.__c = e.__(), B = t;
}
function Te(e, t) {
	return !e || e.length !== t.length || t.some(function(t, n) {
		return t !== e[n];
	});
}
function Ee(e, t) {
	return typeof t == "function" ? t(e) : t;
}
//#endregion
//#region src/personalizer/spec.ts
var De = 2.5, Oe = 2.6202, ke = .12020000000000008 / 2;
function Ae(e, t) {
	let n = Pe(t);
	return e === "mosaic" ? De * n + ke * 2 : Oe;
}
function J(e, t) {
	let n = t.faceInset;
	return {
		x: e.x + e.width * n,
		y: e.y + e.height * n,
		width: e.width * (1 - n * 2),
		height: e.height * (1 - n * 2)
	};
}
var je = 300, Me = 200, Ne = 110, Pe = (e) => Math.round(Math.sqrt(e));
function Fe(e, t) {
	let n = Pe(t), r = Ae(e, t);
	return {
		count: t,
		columns: n,
		photos: e === "mosaic" ? 1 : t,
		idealPixels: Math.round(r * je),
		usablePixels: Math.round(r * Me),
		minPixels: Math.round(r * Ne),
		inches: r,
		faceInset: ke / r
	};
}
function Ie(e, t, n) {
	let r = Math.min(t, n);
	return r >= e.usablePixels ? "good" : r >= e.minPixels ? "soft" : "refused";
}
function Le(e, t, n) {
	return Math.round(Math.min(t, n) / e.inches);
}
//#endregion
//#region node_modules/preact/jsx-runtime/dist/jsxRuntime.module.js
var Re = 0;
Array.isArray;
function Y(e, t, n, r, a, o) {
	t ||= {};
	var s, c, l = t;
	if ("ref" in l) for (c in l = {}, t) c == "ref" ? s = t[c] : l[c] = t[c];
	var u = {
		type: e,
		props: l,
		key: n,
		ref: s,
		__k: null,
		__: null,
		__b: 0,
		__e: null,
		__c: null,
		constructor: void 0,
		__v: --Re,
		__i: -1,
		__u: 0,
		__source: a,
		__self: o
	};
	if (typeof e == "function" && (s = e.defaultProps)) for (c in s) l[c] === void 0 && (l[c] = s[c]);
	return i.vnode && i.vnode(u), u;
}
//#endregion
//#region src/personalizer/Cropper.tsx
var ze = [
	"tl",
	"tr",
	"bl",
	"br"
], X = (e, t, n) => Math.min(n, Math.max(t, e));
function Be({ src: e, width: t, height: n, crop: r, spec: i, onChange: a, onDone: o, onCancel: s }) {
	let c = K(null), l = Math.min(t, n), u = Math.min(i.minPixels, l), [d, f] = W(() => {
		let e = X(r.width * t || l, u, l);
		return {
			x: X(r.x * t, 0, t - e),
			y: X(r.y * n, 0, n - e),
			side: e
		};
	}), [p, m] = W({
		w: 0,
		h: 0
	});
	G(() => {
		let e = c.current;
		if (!e) return;
		let r = () => {
			let r = getComputedStyle(e), i = {
				w: e.clientWidth - parseFloat(r.paddingLeft) - parseFloat(r.paddingRight),
				h: e.clientHeight - parseFloat(r.paddingTop) - parseFloat(r.paddingBottom)
			};
			if (i.w <= 0 || i.h <= 0) return;
			let a = Math.min(i.w / t, i.h / n);
			m({
				w: Math.round(t * a),
				h: Math.round(n * a)
			});
		};
		r();
		let i = new ResizeObserver(r);
		return i.observe(e), () => i.disconnect();
	}, [t, n]);
	let h = K(a);
	h.current = a, G(() => {
		h.current({
			x: d.x / t,
			y: d.y / n,
			width: d.side / t,
			height: d.side / n
		});
	}, [
		d,
		t,
		n
	]);
	let g = K(s);
	g.current = s, G(() => {
		let e = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		let t = (e) => {
			e.key === "Escape" && g.current();
		};
		return document.addEventListener("keydown", t), () => {
			document.body.style.overflow = e, document.removeEventListener("keydown", t);
		};
	}, []);
	let _ = K(null), v = () => p.w > 0 ? t / p.w : 1, y = (e) => (t) => {
		t.preventDefault(), t.stopPropagation(), t.currentTarget.setPointerCapture(t.pointerId), _.current = {
			mode: e,
			x: t.clientX,
			y: t.clientY,
			box: d
		};
	}, b = (e) => {
		let r = _.current;
		if (!r) return;
		let i = v(), a = (e.clientX - r.x) * i, o = (e.clientY - r.y) * i;
		if (r.mode === "move") {
			f({
				x: X(r.box.x + a, 0, t - r.box.side),
				y: X(r.box.y + o, 0, n - r.box.side),
				side: r.box.side
			});
			return;
		}
		f(x(r.mode, r.box, a, o));
	};
	function x(e, r, i, a) {
		let o = e === "tr" || e === "br", s = e === "bl" || e === "br", c = o ? r.x : r.x + r.side, l = s ? r.y : r.y + r.side, d = r.side + (o ? i : -i), f = r.side + (s ? a : -a), p = Math.min(o ? t - c : c, s ? n - l : l), m = X(Math.max(d, f), u, p);
		return {
			x: o ? c : c - m,
			y: s ? l : l - m,
			side: m
		};
	}
	let S = (e) => {
		_.current &&= (e.currentTarget.releasePointerCapture(e.pointerId), null);
	}, C = (e) => {
		let r = e.shiftKey ? d.side * .2 : Math.max(d.side * .04, 1), i = (e, r) => f((i) => ({
			x: X(i.x + e, 0, t - i.side),
			y: X(i.y + r, 0, n - i.side),
			side: i.side
		})), a = (e) => f((r) => {
			let i = X(r.side + e, u, l);
			return {
				x: X(r.x - (i - r.side) / 2, 0, t - i),
				y: X(r.y - (i - r.side) / 2, 0, n - i),
				side: i
			};
		});
		switch (e.key) {
			case "ArrowLeft":
				i(-r, 0);
				break;
			case "ArrowRight":
				i(r, 0);
				break;
			case "ArrowUp":
				i(0, -r);
				break;
			case "ArrowDown":
				i(0, r);
				break;
			case "+":
			case "=":
				a(r);
				break;
			case "-":
			case "_":
				a(-r);
				break;
			default: return;
		}
		e.preventDefault();
	}, w = () => f({
		x: (t - l) / 2,
		y: (n - l) / 2,
		side: l
	}), T = Le(i, d.side, d.side), E = d.side < i.usablePixels, D = d.side <= u + 1, O = d.x / t * 100, k = d.y / n * 100, A = d.side / t * 100, j = d.side / n * 100, M = [
		{
			left: 0,
			right: 0,
			top: 0,
			height: `${k}%`
		},
		{
			left: 0,
			right: 0,
			top: `${k + j}%`,
			bottom: 0
		},
		{
			left: 0,
			width: `${O}%`,
			top: `${k}%`,
			height: `${j}%`
		},
		{
			left: `${O + A}%`,
			right: 0,
			top: `${k}%`,
			height: `${j}%`
		}
	];
	return /* @__PURE__ */ Y("div", {
		class: "ks-cropper",
		children: [
			/* @__PURE__ */ Y("header", {
				class: "ks-cropper__head",
				children: [/* @__PURE__ */ Y("h2", {
					class: "ks-cropper__title",
					children: "Choose the square"
				}), /* @__PURE__ */ Y("button", {
					type: "button",
					class: "ks-cropper__close",
					onClick: s,
					"aria-label": "Cancel",
					children: "✕"
				})]
			}),
			/* @__PURE__ */ Y("div", {
				class: "ks-cropper__stage",
				ref: c,
				children: /* @__PURE__ */ Y("div", {
					class: "ks-cropper__frame",
					style: p.w ? {
						width: `${p.w}px`,
						height: `${p.h}px`
					} : { opacity: 0 },
					onPointerDown: y("move"),
					onPointerMove: b,
					onPointerUp: S,
					onPointerCancel: S,
					children: [
						/* @__PURE__ */ Y("img", {
							class: "ks-cropper__image",
							src: e,
							alt: "",
							draggable: !1
						}),
						M.map((e, t) => /* @__PURE__ */ Y("div", {
							class: "ks-cropper__shade",
							style: e,
							"aria-hidden": "true"
						}, t)),
						/* @__PURE__ */ Y("div", {
							class: "ks-cropper__box",
							style: {
								left: `${O}%`,
								top: `${k}%`,
								width: `${A}%`,
								height: `${j}%`
							},
							tabIndex: 0,
							role: "group",
							"aria-label": "Crop square. Arrow keys move it, plus and minus resize it.",
							onKeyDown: C,
							children: [
								/* @__PURE__ */ Y("div", {
									class: "ks-cropper__mask",
									"aria-hidden": "true",
									children: /* @__PURE__ */ Y("div", {
										class: "ks-cropper__face",
										style: { inset: `${i.faceInset * 100}%` }
									})
								}),
								/* @__PURE__ */ Y("div", {
									class: "ks-cropper__thirds",
									"aria-hidden": "true"
								}),
								ze.map((e) => /* @__PURE__ */ Y("div", {
									class: `ks-cropper__handle is-${e}`,
									onPointerDown: y(e),
									onPointerMove: b,
									onPointerUp: S,
									onPointerCancel: S
								}, e))
							]
						})
					]
				})
			}),
			/* @__PURE__ */ Y("footer", {
				class: "ks-cropper__foot",
				children: [
					/* @__PURE__ */ Y("p", {
						class: `ks-cropper__note${E ? " is-soft" : ""}`,
						children: D ? `That's as tight as this photo goes — ${T} dpi` : E ? `Tight enough to print a little soft — ${T} dpi` : "Drag to move. Pull a corner to resize."
					}),
					/* @__PURE__ */ Y("p", {
						class: "ks-cropper__wrapnote",
						children: "The shaded border wraps around the edge of the magnet."
					}),
					/* @__PURE__ */ Y("div", {
						class: "ks-cropper__actions",
						children: [/* @__PURE__ */ Y("button", {
							type: "button",
							class: "ks-cropper__reset",
							onClick: w,
							children: "Reset"
						}), /* @__PURE__ */ Y("button", {
							type: "button",
							class: "ks-btn ks-btn--primary",
							onClick: o,
							children: "Use this crop"
						})]
					})
				]
			})
		]
	});
}
//#endregion
//#region src/personalizer/crop-style.ts
function Ve(e, t = 1, n = 0, r = 0) {
	return {
		width: `${100 * t / e.width}%`,
		height: `${100 * t / e.height}%`,
		left: `${-(100 * t * (e.x / e.width) + 100 * n)}%`,
		top: `${-(100 * t * (e.y / e.height) + 100 * r)}%`
	};
}
//#endregion
//#region src/personalizer/image.ts
function He(e) {
	return URL.createObjectURL(e);
}
async function Ue(e) {
	try {
		let t = await createImageBitmap(e), n = {
			width: t.width,
			height: t.height,
			opaque: !1
		};
		return t.close(), n;
	} catch {
		return {
			width: 0,
			height: 0,
			opaque: !0
		};
	}
}
function We(e, t) {
	if (e === 0 || t === 0) return {
		x: 0,
		y: 0,
		width: 1,
		height: 1
	};
	let n = Math.min(e, t);
	return {
		x: (e - n) / 2 / e,
		y: (t - n) / 2 / t,
		width: n / e,
		height: n / t
	};
}
function Ge(e) {
	return new Promise((t, n) => {
		let r = new Image();
		r.onload = () => t(r), r.onerror = () => n(/* @__PURE__ */ Error("Could not decode image")), r.src = e;
	});
}
function Ke(e, t, n, r, i, a) {
	e.beginPath(), e.moveTo(t + a, n), e.arcTo(t + r, n, t + r, n + i, a), e.arcTo(t + r, n + i, t, n + i, a), e.arcTo(t, n + i, t, n, a), e.arcTo(t, n, t + r, n, a), e.closePath();
}
var qe = "#F3EFE7", Je = "#FFFFFF";
async function Ye(e, t, n) {
	let r = document.createElement("canvas");
	r.width = 900, r.height = 900;
	let i = r.getContext("2d");
	if (!i) throw Error("Canvas unavailable");
	i.fillStyle = qe, i.fillRect(0, 0, 900, 900);
	let { columns: a } = t, o = 16.2, s = (810 - o * (a - 1)) / a, c = s * .055, l = s * .05, u = await Promise.all(n.map((e) => Ge(e.objectUrl)));
	for (let r = 0; r < t.count; r++) {
		let d = Math.floor(r / a), f = 45 + r % a * (s + o), p = 45 + d * (s + o);
		i.save(), i.shadowColor = "rgba(91, 82, 71, 0.30)", i.shadowBlur = s * .09, i.shadowOffsetY = s * .03, i.fillStyle = Je, Ke(i, f, p, s, s, l), i.fill(), i.restore();
		let m = f + c, h = p + c, g = s - c * 2;
		if (i.save(), Ke(i, m, h, g, g, l * .4), i.clip(), e === "mosaic") {
			let e = n[0], r = u[0];
			if (e && r) {
				let n = s * a + o * (a - 1), c = J(e.crop, t), l = c.x * r.naturalWidth, u = c.y * r.naturalHeight, d = c.width * r.naturalWidth, f = c.height * r.naturalHeight;
				i.drawImage(r, l, u, d, f, 45, 45, n, n);
			}
		} else {
			let e = n[r], a = u[r];
			if (e && a) {
				let n = J(e.crop, t), r = n.x * a.naturalWidth, o = n.y * a.naturalHeight, s = n.width * a.naturalWidth, c = n.height * a.naturalHeight;
				i.drawImage(a, r, o, s, c, m, h, g, g);
			}
		}
		i.restore();
	}
	return new Promise((e, t) => {
		r.toBlob((n) => n ? e(n) : t(/* @__PURE__ */ Error("Could not render the preview")), "image/jpeg", .86);
	});
}
//#endregion
//#region src/personalizer/UploadDial.tsx
var Xe = 15.9155;
function Ze({ progress: e, label: t, indeterminate: n }) {
	let r = Math.round(Math.min(1, Math.max(0, e)) * 100), i = t ? {
		role: "progressbar",
		"aria-label": n ? `Checking before uploading ${t}` : t,
		"aria-valuemin": 0,
		"aria-valuemax": 100,
		...n ? {} : { "aria-valuenow": r }
	} : { "aria-hidden": !0 };
	return /* @__PURE__ */ Y("span", {
		class: `ks-dial${n ? " is-indeterminate" : ""}`,
		...i,
		children: /* @__PURE__ */ Y("svg", {
			class: "ks-dial__ring",
			viewBox: "0 0 36 36",
			children: [
				/* @__PURE__ */ Y("circle", {
					class: "ks-dial__track",
					cx: "18",
					cy: "18",
					r: Xe
				}),
				/* @__PURE__ */ Y("circle", {
					class: "ks-dial__arc",
					cx: "18",
					cy: "18",
					r: Xe,
					style: n ? { strokeDasharray: "25 75" } : { strokeDashoffset: 100 - r }
				}),
				!n && /* @__PURE__ */ Y("text", {
					class: "ks-dial__count",
					x: "18",
					y: "18",
					children: [r, "%"]
				})
			]
		})
	});
}
//#endregion
//#region src/personalizer/LivePreview.tsx
function Qe(e) {
	return e && (e.status === "uploading" || e.status === "ready" || e.status === "failed") ? e : null;
}
function $e(e) {
	return e ? e.status === "ready" ? e.crop : e.status === "uploading" ? We(e.width, e.height) : null : null;
}
function et(e, t, n) {
	let r = e - 1, i = `${e * 100}% ${e * 100}%`;
	return r <= 0 ? {
		backgroundSize: i,
		backgroundPosition: "0% 0%"
	} : {
		backgroundSize: i,
		backgroundPosition: `${t / r * 100}% ${n / r * 100}%`
	};
}
function tt({ spec: e, source: t, crop: n, isActive: r, onAdjust: i, onPick: a }) {
	let { columns: o, count: s } = e, c = t !== null && n !== null, l = t?.status === "ready";
	return /* @__PURE__ */ Y("button", {
		type: "button",
		class: `ks-pv__mosaic${r ? " is-active" : ""}${t?.status === "uploading" ? " is-pending" : ""}`,
		disabled: c && !l,
		onClick: c ? i : a,
		"aria-label": t?.status === "uploading" ? "Your photo, uploading" : c ? "Adjust your photo" : "Choose your photo",
		children: [
			/* @__PURE__ */ Y("span", {
				class: "ks-pv__mosaic-grid ks-set--mosaic",
				children: Array.from({ length: s }, (r, i) => {
					let a = i % o, s = Math.floor(i / o);
					return /* @__PURE__ */ Y("span", {
						class: `ks-pv__slice${c ? "" : " ks-pv__slice--wash"}`,
						style: c ? void 0 : et(o, a, s),
						children: c && t && n && /* @__PURE__ */ Y("img", {
							class: "ks-pv__photo",
							src: t.objectUrl,
							alt: "",
							style: Ve(J(n, e), o, a, s)
						})
					}, i);
				})
			}),
			t && t.status === "uploading" && /* @__PURE__ */ Y(Ze, {
				progress: t.progress,
				indeterminate: t.verifying
			}),
			c ? l && /* @__PURE__ */ Y("span", {
				class: "ks-pv__hint ks-pv__hint--mosaic",
				"aria-hidden": "true",
				children: "Adjust"
			}) : /* @__PURE__ */ Y("span", {
				class: "ks-pv__hint ks-pv__hint--pick",
				"aria-hidden": "true",
				children: "+"
			})
		]
	});
}
function nt({ mode: e, spec: t, slots: n, activeIndex: r, nextIndex: i, onAdjust: a, onPick: o }) {
	let { columns: s, count: c } = t;
	if (e === "mosaic") {
		let e = Qe(n[0]), i = $e(e);
		return /* @__PURE__ */ Y("div", {
			class: "ks-pv",
			style: { "--ks-set-columns": s },
			children: /* @__PURE__ */ Y(tt, {
				spec: t,
				source: e,
				crop: i,
				isActive: r !== null,
				onAdjust: () => a(0),
				onPick: () => o(0)
			})
		});
	}
	return /* @__PURE__ */ Y("div", {
		class: "ks-pv",
		style: { "--ks-set-columns": s },
		children: /* @__PURE__ */ Y("div", {
			class: "ks-set ks-pv__set",
			children: Array.from({ length: c }, (e, s) => {
				let c = Qe(n[s]), l = $e(c), u = r === s, d = s % 9 + 1;
				if (!c || !l) return /* @__PURE__ */ Y("button", {
					type: "button",
					class: `ks-magnet ks-pv__tile is-empty${u && !c ? " is-active" : ""}${i === s ? " is-next" : ""}`,
					"data-wash": d,
					onClick: () => o(s),
					"aria-label": `Choose photo ${s + 1}`,
					children: [/* @__PURE__ */ Y("div", { class: "ks-magnet__well" }), /* @__PURE__ */ Y("span", {
						class: "ks-pv__hint",
						"aria-hidden": "true",
						children: "+"
					})]
				}, s);
				let f = c.status === "ready";
				return /* @__PURE__ */ Y("button", {
					type: "button",
					class: `ks-magnet ks-pv__tile${u ? " is-active" : ""}${c.status === "uploading" ? " is-pending" : ""}`,
					disabled: !f,
					onClick: () => a(s),
					"aria-label": c.status === "uploading" ? `Photo ${s + 1}, uploading` : `Adjust photo ${s + 1}`,
					children: [
						/* @__PURE__ */ Y("div", {
							class: "ks-magnet__well ks-pv__well",
							children: /* @__PURE__ */ Y("img", {
								class: "ks-pv__photo",
								src: c.objectUrl,
								alt: "",
								style: Ve(J(l, t), 1, 0, 0)
							})
						}),
						c.status === "uploading" && /* @__PURE__ */ Y(Ze, {
							progress: c.progress,
							indeterminate: c.verifying
						}),
						f && /* @__PURE__ */ Y("span", {
							class: "ks-pv__hint",
							"aria-hidden": "true",
							children: "Adjust"
						})
					]
				}, s);
			})
		})
	});
}
//#endregion
//#region src/personalizer/cart.ts
var rt = class extends Error {};
function it(e) {
	let t = Number(e.total_price);
	return Number.isFinite(t) ? t : null;
}
async function at() {
	try {
		return it(await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((e) => e.json()));
	} catch {
		return null;
	}
}
async function ot(n, r) {
	let i = {
		Preview: n.previewUrl,
		_keys: JSON.stringify(n.slots.map((e) => e.key)),
		_crops: JSON.stringify(n.slots.map((e) => ({
			x: Number(e.crop.x.toFixed(6)),
			y: Number(e.crop.y.toFixed(6)),
			w: Number(e.crop.width.toFixed(6)),
			h: Number(e.crop.height.toFixed(6))
		}))),
		_source: JSON.stringify(n.slots.map((e) => ({
			w: e.width,
			h: e.height,
			soft: e.soft
		})))
	};
	n.upgrade && (i._upgrade = n.upgrade);
	let a = Math.max(1, Math.round(n.quantity ?? 1)), o = t.createPromise();
	document.dispatchEvent(new t({
		action: "add",
		context: "product",
		lines: [{
			merchandiseId: n.variantId,
			quantity: a
		}],
		promise: o.promise
	}));
	let s;
	try {
		s = await fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			body: JSON.stringify({ items: [{
				id: n.variantId,
				quantity: a,
				properties: i
			}] })
		});
	} catch (e) {
		throw o.reject(e), new rt("Lost connection before that reached the cart. Try again.");
	}
	if (!s.ok) {
		let t = await s.json().catch(() => null), n = t?.description ?? "That didn't make it into the cart. Try again in a moment.";
		throw document.dispatchEvent(new e({
			error: t?.message ?? "Add to cart failed",
			code: "INVALID",
			detail: { description: t?.description }
		})), o.reject(Error(n)), new rt(n);
	}
	try {
		let e = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((e) => e.json());
		return o.resolve({
			cart: t.createCartFromAjaxResponse(e),
			detail: {
				items: e.items,
				source: r,
				itemCount: a
			}
		}), { totalCents: it(e) };
	} catch (e) {
		return o.reject(e), { totalCents: null };
	}
}
//#endregion
//#region src/personalizer/booth.ts
var st = "booth", ct = "keepset:booth", lt = "/apps/booth/submit", ut = class extends Error {}, dt = class extends Error {};
function ft() {
	let e = null;
	try {
		e = new URL(window.location.href).searchParams.get(st);
	} catch {}
	if (e === "") return pt(), null;
	try {
		return e ? (sessionStorage.setItem(ct, e), e) : sessionStorage.getItem(ct);
	} catch {
		return e;
	}
}
function pt() {
	try {
		sessionStorage.removeItem(ct);
	} catch {}
}
async function mt(e) {
	let t;
	try {
		t = await fetch(lt, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			body: JSON.stringify({
				token: e.token,
				variantId: e.variantId,
				quantity: 1,
				customerName: e.customerName,
				customerEmail: e.customerEmail,
				customerPhone: e.customerPhone,
				customerSubscribe: e.customerSubscribe,
				previewUrl: e.previewUrl,
				keys: e.slots.map((e) => e.key),
				crops: e.slots.map((e) => ({
					x: Number(e.crop.x.toFixed(6)),
					y: Number(e.crop.y.toFixed(6)),
					w: Number(e.crop.width.toFixed(6)),
					h: Number(e.crop.height.toFixed(6))
				})),
				source: e.slots.map((e) => ({
					w: e.width,
					h: e.height,
					soft: e.soft
				}))
			})
		});
	} catch {
		throw new dt("Lost connection before that reached the booth. Try again.");
	}
	if (t.status === 403) throw new ut("That booth has closed. You can still order it to be posted.");
	let n = await t.json().catch(() => null);
	if (!t.ok || !n?.code) throw n?.error && console.error("[keepset] booth refused the submission:", n.error), new dt("That didn't reach the booth. Try again in a moment.");
	return { code: n.code };
}
//#endregion
//#region src/personalizer/BoothDetails.tsx
function ht({ busy: e, onSubmit: t, onCancel: n }) {
	let [r, i] = W(""), [a, o] = W(""), [s, c] = W(""), [l, u] = W(!1), d = K(null);
	G(() => {
		d.current?.focus();
	}, []), G(() => {
		let t = (t) => {
			t.key === "Escape" && !e && n();
		};
		return document.addEventListener("keydown", t), () => document.removeEventListener("keydown", t);
	}, [e, n]);
	let f = r.trim() !== "", p = /\S+@\S+/.test(a), m = s.replace(/\D/g, "").length >= 10;
	function h(n) {
		n.preventDefault(), u(!0), !(!f || e) && t({
			name: r.trim(),
			email: a.trim(),
			phone: s.trim(),
			subscribe: p
		});
	}
	return /* @__PURE__ */ Y("div", {
		class: "ks-pz__modal",
		role: "dialog",
		"aria-modal": "true",
		"aria-label": "Your details",
		onClick: (t) => {
			t.target === t.currentTarget && !e && n();
		},
		children: /* @__PURE__ */ Y("form", {
			class: "ks-pz__sheet",
			onSubmit: h,
			children: [
				/* @__PURE__ */ Y("h2", {
					class: "ks-pz__sheet-title",
					children: "Nearly there"
				}),
				/* @__PURE__ */ Y("p", {
					class: "ks-pz__sheet-text",
					children: "We need a name for your magnets. Leave a phone or an email if you'd like us to tell you when they're ready — either one, both, or neither."
				}),
				/* @__PURE__ */ Y("label", {
					class: "ks-pz__field",
					children: [/* @__PURE__ */ Y("span", {
						class: "ks-pz__field-label",
						children: "Your name"
					}), /* @__PURE__ */ Y("input", {
						ref: d,
						class: "ks-pz__input",
						type: "text",
						name: "name",
						autocomplete: "given-name",
						enterkeyhint: "next",
						value: r,
						onInput: (e) => i(e.target.value)
					})]
				}),
				/* @__PURE__ */ Y("label", {
					class: "ks-pz__field",
					children: [/* @__PURE__ */ Y("span", {
						class: "ks-pz__field-label",
						children: "Email (optional)"
					}), /* @__PURE__ */ Y("input", {
						class: "ks-pz__input",
						type: "email",
						name: "email",
						autocomplete: "email",
						inputMode: "email",
						enterkeyhint: "next",
						value: a,
						onInput: (e) => o(e.target.value)
					})]
				}),
				p && /* @__PURE__ */ Y("p", {
					class: "ks-pz__optin-note",
					children: "We'll email you when your magnets are ready. We'll also send market dates and the odd new design — a few times a year, never more, and you can unsubscribe from any of them."
				}),
				/* @__PURE__ */ Y("label", {
					class: "ks-pz__field",
					children: [/* @__PURE__ */ Y("span", {
						class: "ks-pz__field-label",
						children: "Phone (optional)"
					}), /* @__PURE__ */ Y("input", {
						class: "ks-pz__input",
						type: "tel",
						name: "phone",
						autocomplete: "tel",
						inputMode: "tel",
						enterkeyhint: "done",
						value: s,
						onInput: (e) => c(e.target.value)
					})]
				}),
				m && /* @__PURE__ */ Y("p", {
					class: "ks-pz__optin-note",
					children: "We'll text this number when your magnets are ready — about this order only."
				}),
				l && !f && /* @__PURE__ */ Y("p", {
					class: "ks-pz__sheet-error",
					role: "alert",
					children: "We need a name to call out."
				}),
				/* @__PURE__ */ Y("div", {
					class: "ks-pz__sheet-actions",
					children: [/* @__PURE__ */ Y("button", {
						type: "submit",
						class: "ks-btn ks-btn--primary ks-pz__submit",
						disabled: e,
						children: e ? "Sending…" : "Send to the booth"
					}), /* @__PURE__ */ Y("button", {
						type: "button",
						class: "ks-pz__again",
						onClick: n,
						disabled: e,
						children: "Back"
					})]
				})
			]
		})
	});
}
//#endregion
//#region src/personalizer/turnstile.ts
var gt = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit", _t = null;
function vt() {
	return _t || (_t = new Promise((e, t) => {
		if (window.turnstile) return e(window.turnstile);
		let n = document.createElement("script");
		n.src = gt, n.async = !0, n.defer = !0, n.onload = () => {
			window.turnstile ? e(window.turnstile) : t(/* @__PURE__ */ Error("Turnstile loaded without exposing its API"));
		}, n.onerror = () => t(/* @__PURE__ */ Error("Turnstile failed to load")), document.head.append(n);
	}), _t);
}
var yt = 2e4, bt = class {
	#e;
	#t = null;
	#n = null;
	#r = null;
	#i = null;
	#a = Promise.resolve();
	constructor(e) {
		this.#e = e;
	}
	#o() {
		return this.#r ??= this.#s(), this.#r;
	}
	async #s() {
		let e = await vt(), t = document.createElement("div");
		return t.className = "ks-turnstile", document.body.append(t), this.#n = e.render(t, {
			sitekey: this.#e,
			execution: "execute",
			appearance: "interaction-only",
			callback: (e) => {
				this.#c((t) => t.resolve(e));
			},
			"error-callback": () => {
				this.#c((e) => e.reject(/* @__PURE__ */ Error("Turnstile could not verify this browser")));
			},
			"expired-callback": () => {
				this.#c((e) => e.reject(/* @__PURE__ */ Error("Verification expired")));
			}
		}), this.#t = t, e;
	}
	#c(e) {
		let t = this.#i;
		!t || t.settled || (t.settled = !0, clearTimeout(t.timer), this.#i = null, e(t));
	}
	async token() {
		let e = await this.#o(), t = this.#a.then(() => this.#l(e), () => this.#l(e));
		return this.#a = t.catch(() => void 0), t;
	}
	#l(e) {
		return new Promise((t, n) => {
			let r = {
				resolve: t,
				reject: n,
				settled: !1,
				timer: setTimeout(() => {
					r.settled || this.#i !== r || (r.settled = !0, this.#i = null, n(/* @__PURE__ */ Error("Verification timed out")));
				}, yt)
			};
			this.#i = r, e.reset(this.#n), e.execute(this.#n);
		});
	}
	destroy() {
		this.#i &&= (clearTimeout(this.#i.timer), this.#i.settled = !0, null), this.#t?.remove(), this.#t = null, this.#n = null, this.#r = null;
	}
}, Z = class extends Error {
	code;
	retryable;
	constructor(e, t, n) {
		super(t), this.code = e, this.retryable = n;
	}
}, xt = {
	too_large: "That photo is larger than 15 MB. Try one straight from your camera roll.",
	unsupported_type: "That file isn't a photo we can print. JPEG, PNG, WebP or HEIC.",
	rate_limited: "That was a lot of photos at once. Give it a minute and try again.",
	verification_failed: "We couldn't verify that upload. Reload the page and try again."
};
async function St(e, t) {
	let n = t.token;
	return new Promise((r, i) => {
		let a = new XMLHttpRequest();
		a.open("POST", `${t.apiUrl}/v1/uploads`), a.setRequestHeader("X-Keepset-Turnstile", n), a.responseType = "json", a.upload.addEventListener("progress", (e) => {
			e.lengthComputable && t.onProgress?.(e.loaded / e.total);
		}), a.addEventListener("load", () => {
			if (a.status === 201) return t.onProgress?.(1), r(a.response);
			let e = (a.response ?? {}).error?.code ?? "unknown";
			i(new Z(e, xt[e] ?? "That photo didn't upload. Try again in a moment.", e === "rate_limited" || a.status >= 500));
		}), a.addEventListener("error", () => i(new Z("network", "Lost connection. Check your signal and try again.", !0))), a.addEventListener("abort", () => i(new Z("aborted", "Upload cancelled.", !1))), t.signal?.addEventListener("abort", () => a.abort(), { once: !0 }), a.send(e);
	});
}
//#endregion
//#region src/personalizer/money.ts
function Q(e, t) {
	try {
		return new Intl.NumberFormat(void 0, {
			style: "currency",
			currency: t
		}).format(e / 100);
	} catch {
		return (e / 100).toFixed(2);
	}
}
//#endregion
//#region src/personalizer/BulkTiers.tsx
function Ct(e) {
	return !e.priceCents || !e.compareAtCents ? null : Math.round((1 - e.priceCents / e.compareAtCents) * 100);
}
function wt(e, t) {
	let n = e.minQuantity ?? 0;
	return t?.minQuantity ? `${n}–${t.minQuantity - 1}` : `${n} or more`;
}
function Tt({ tiers: e, active: t, quantity: n, onQuantity: r, floor: i, ceiling: a, currency: o }) {
	let [s, c] = W(String(n));
	G(() => c(String(n)), [n]);
	let l = (e) => {
		let t = Math.round(Number(e));
		if (!Number.isFinite(t) || t <= 0) return r(i);
		r(Math.max(i, a ? Math.min(t, a) : t));
	}, u = t?.priceCents ? t.priceCents * n : null, d = a !== null && Number(s) > a, f = t?.compareAtCents ?? 0, p = f && t?.priceCents ? (f - t.priceCents) * n : 0;
	return /* @__PURE__ */ Y("div", {
		class: "ks-bulk",
		children: [
			/* @__PURE__ */ Y("div", {
				class: "ks-bulk__pick",
				children: [/* @__PURE__ */ Y("label", {
					class: "ks-bulk__field",
					children: [/* @__PURE__ */ Y("span", {
						class: "ks-eyebrow",
						children: "How many magnets"
					}), /* @__PURE__ */ Y("input", {
						class: "ks-bulk__input",
						type: "number",
						inputMode: "numeric",
						min: i,
						...a ? { max: a } : {},
						step: 1,
						value: s,
						onInput: (e) => c(e.target.value),
						onBlur: (e) => l(e.target.value),
						onKeyDown: (e) => {
							e.key === "Enter" && l(e.target.value);
						}
					})]
				}), /* @__PURE__ */ Y("div", {
					class: "ks-bulk__sum",
					"aria-live": "polite",
					children: t && /* @__PURE__ */ Y(T, { children: [
						/* @__PURE__ */ Y("span", {
							class: "ks-bulk__each",
							children: [
								t.price,
								" each",
								f > 0 && /* @__PURE__ */ Y(T, { children: [" ", /* @__PURE__ */ Y("s", {
									class: "ks-bulk__was",
									children: Q(f, o)
								})] })
							]
						}),
						u !== null && /* @__PURE__ */ Y("span", {
							class: "ks-bulk__total",
							children: Q(u, o)
						}),
						p > 0 && /* @__PURE__ */ Y("span", {
							class: "ks-bulk__saved",
							children: [
								Q(p, o),
								" less than ",
								n,
								" singles"
							]
						})
					] })
				})]
			}),
			d && /* @__PURE__ */ Y("p", {
				class: "ks-bulk__note ks-bulk__note--over",
				children: [
					"Orders above ",
					a,
					" are worth a conversation first, so we can agree a date that holds. ",
					/* @__PURE__ */ Y("a", {
						href: "/pages/contact",
						children: "Tell us what you need."
					})
				]
			}),
			/* @__PURE__ */ Y("table", {
				class: "ks-bulk__ladder",
				children: [/* @__PURE__ */ Y("caption", {
					class: "ks-eyebrow",
					children: ["Price per magnet", f > 0 && /* @__PURE__ */ Y("span", {
						class: "ks-bulk__anchor",
						children: [" · one on its own is ", Q(f, o)]
					})]
				}), /* @__PURE__ */ Y("tbody", { children: e.map((n, r) => {
					let i = Ct(n);
					return /* @__PURE__ */ Y("tr", {
						class: n.id === t?.id ? "is-active" : void 0,
						"aria-current": n.id === t?.id ? "true" : void 0,
						children: [
							/* @__PURE__ */ Y("th", {
								scope: "row",
								children: wt(n, e[r + 1])
							}),
							/* @__PURE__ */ Y("td", { children: n.price }),
							f > 0 && /* @__PURE__ */ Y("td", {
								class: "ks-bulk__off",
								children: i === null ? "" : `${i}% off`
							})
						]
					}, n.id);
				}) })]
			})
		]
	});
}
//#endregion
//#region src/personalizer/track.ts
function $(e, t = {}) {
	try {
		window.KeepsetAnalytics?.track?.(e, t);
	} catch {}
}
//#endregion
//#region src/personalizer/App.tsx
var Et = (e) => Array.from({ length: e }, () => ({ status: "empty" })), Dt = "https://make.keepsetco.com";
function Ot(e, t) {
	return e.count <= 1 || typeof e.priceCents != "number" ? null : Q(Math.round(e.priceCents / e.count), t);
}
function kt({ cartCents: e, setCents: t, threshold: n, currency: r }) {
	let i = e + t, a = i >= n, o = Math.min(100, e / n * 100), s = Math.min(100 - o, t / n * 100);
	return /* @__PURE__ */ Y("div", {
		class: `ks-pz__ship${a ? " is-clear" : ""}`,
		children: [/* @__PURE__ */ Y("div", {
			class: "ks-pz__ship-track",
			children: [o > 0 && /* @__PURE__ */ Y("div", {
				class: "ks-pz__ship-fill ks-pz__ship-fill--cart",
				style: { width: `${o}%` }
			}), /* @__PURE__ */ Y("div", {
				class: "ks-pz__ship-fill",
				style: { width: `${Math.max(2, s)}%` }
			})]
		}), /* @__PURE__ */ Y("p", {
			class: "ks-pz__ship-note",
			role: "status",
			children: a ? e > 0 ? "Free US shipping — this set takes your order over the threshold" : "Free US shipping on this set" : `${Q(n - i, r)} more for free US shipping — or collect free in Brownsburg`
		})]
	});
}
function At({ totalCents: e, threshold: t, currency: n, onClose: r, onBuildAnother: i }) {
	let a = K(null);
	G(() => {
		a.current?.showModal();
	}, []);
	let o = e >= t, s = o ? 100 : Math.max(3, Math.round(e / t * 100)), c = Q(t - e, n);
	return /* @__PURE__ */ Y("dialog", {
		class: `ks-ship-pop${o ? " is-clear" : ""}`,
		ref: a,
		"aria-labelledby": "ks-ship-pop-title",
		onClose: r,
		children: [
			/* @__PURE__ */ Y("p", {
				class: "ks-ship-pop__title",
				id: "ks-ship-pop-title",
				children: o ? "Free shipping unlocked" : `${c} to go`
			}),
			/* @__PURE__ */ Y("div", {
				class: "ks-pz__ship-track",
				children: /* @__PURE__ */ Y("div", {
					class: "ks-pz__ship-fill",
					style: { width: `${s}%` }
				})
			}),
			/* @__PURE__ */ Y("p", {
				class: "ks-ship-pop__body",
				children: o ? "Your order is over the threshold, so US shipping is on us." : `Add ${c} more and US shipping is free. Or collect free in Brownsburg — no minimum.`
			}),
			o ? /* @__PURE__ */ Y("a", {
				class: "ks-btn ks-btn--primary ks-ship-pop__go",
				href: "/cart",
				children: "Go to cart"
			}) : /* @__PURE__ */ Y("button", {
				type: "button",
				class: "ks-btn ks-btn--primary ks-ship-pop__go",
				onClick: () => {
					a.current?.close(), i();
				},
				children: "Build another"
			}),
			!o && /* @__PURE__ */ Y("a", {
				class: "ks-ship-pop__browse",
				href: "/collections/all",
				children: "See everything"
			}),
			o ? /* @__PURE__ */ Y("button", {
				type: "button",
				class: "ks-ship-pop__dismiss",
				onClick: () => {
					a.current?.close(), i();
				},
				children: "Keep building"
			}) : /* @__PURE__ */ Y("a", {
				class: "ks-ship-pop__dismiss",
				href: "/cart",
				children: "Go to cart"
			})
		]
	});
}
function jt({ totalCents: e, threshold: t, currency: n }) {
	return e >= t ? /* @__PURE__ */ Y("p", {
		class: "ks-pz__unlocked",
		children: "Free US shipping unlocked."
	}) : /* @__PURE__ */ Y("p", {
		class: "ks-pz__done-ship",
		children: [Q(t - e, n), " more in your cart and US shipping is free — or collect free in Brownsburg."]
	});
}
function Mt({ config: e }) {
	let t = e.mode === "bulk", [r, i] = W(() => e.initialVariantId ?? e.variants.find((e) => e.available)?.id ?? e.variants[0]?.id ?? ""), a = q(() => e.variants.filter((e) => typeof e.minQuantity == "number").sort((e, t) => (e.minQuantity ?? 0) - (t.minQuantity ?? 0)), [e.variants]), o = a[0]?.minQuantity ?? 1, s = e.maxQuantity && e.maxQuantity > 0 ? e.maxQuantity : null, [c, l] = W(o), u = ye((e) => {
		let t = a[0];
		for (let n of a) e >= (n.minQuantity ?? 0) && (t = n);
		return t;
	}, [a]), d = q(() => t ? u(c) ?? e.variants[0] : e.variants.find((e) => e.id === r) ?? e.variants[0], [
		t,
		u,
		c,
		e.variants,
		r
	]), f = q(() => !t || !d?.priceCents ? null : Q(d.priceCents * c, e.currency ?? "USD"), [
		t,
		d?.priceCents,
		c,
		e.currency
	]), p = q(() => {
		if (!t || !d?.priceCents) return;
		let n = a.find((e) => (e.minQuantity ?? 0) > c);
		if (!n?.minQuantity || !n.priceCents) return;
		let r = d.priceCents * c, i = n.priceCents * n.minQuantity;
		if (i >= r) return;
		let o = e.currency ?? "USD", s = n.minQuantity - c;
		return `${n.minQuantity} for ${Q(i, o)} — ${s} more ${s === 1 ? "magnet" : "magnets"}, ${Q(r - i, o)} less than paid`;
	}, [
		t,
		d?.priceCents,
		c,
		a,
		e.currency
	]), m = q(() => Fe(e.mode, d?.count ?? 1), [e.mode, d?.count]), [h, g] = W(() => Et(m.photos)), [_, v] = W(null), [y, b] = W(!1), [x, S] = W(null), [C, w] = W(!1), [E, D] = W(e.cartTotalCents ?? 0), [O, k] = W(!1);
	G(() => {
		if (!e.freeShippingCents) return;
		let t = !0, r = async () => {
			let e = await at();
			t && e !== null && D(e);
		}, i = (e) => {
			let t = e.promise;
			Promise.resolve(t).catch(() => void 0).then(r);
		}, a = () => {
			document.hidden || r();
		};
		return document.addEventListener(n.cartLinesUpdate, i), document.addEventListener(n.cartDiscountUpdate, i), document.addEventListener("visibilitychange", a), window.addEventListener("pageshow", r), () => {
			t = !1, document.removeEventListener(n.cartLinesUpdate, i), document.removeEventListener(n.cartDiscountUpdate, i), document.removeEventListener("visibilitychange", a), window.removeEventListener("pageshow", r);
		};
	}, [e.freeShippingCents]);
	let [A, j] = W(() => ft()), [M, N] = W(null), [P, F] = W(""), [ee, I] = W(!1), L = K(null);
	L.current ||= new bt(e.turnstileSitekey);
	let te = ye((e) => {
		document.getElementById(`ks-pz-file-${e}`)?.click();
	}, []), ne = K(null), re = ye((e) => {
		let t = h[e];
		ne.current = t && t.status === "ready" ? t.crop : null, v(e);
	}, [h]), R = ye((e, t) => {
		g((n) => n.map((n, r) => r === e ? t : n));
	}, []), ie = (t) => {
		let n = e.variants.find((e) => e.id === t);
		if (!n) return;
		let r = Fe(e.mode, n.count);
		i(t), S(null), w(!1), g((t) => {
			if (e.mode === "mosaic") {
				let e = t[0];
				return e && (e.status === "ready" || e.status === "uploading") && Math.min(e.width, e.height) < r.minPixels ? Et(r.photos) : t.slice(0, r.photos);
			}
			return Et(r.photos);
		});
	};
	async function ae(t, n) {
		let r = Date.now(), i = He(n), a = Date.now(), o = L.current.token(), s = null;
		o.then(() => {
			s = Date.now() - a;
		}, () => void 0);
		let c = {
			fileName: n.name,
			objectUrl: i,
			width: 0,
			height: 0,
			soft: !1
		};
		R(t, {
			...c,
			status: "uploading",
			progress: 0,
			verifying: !0
		});
		let l = new AbortController(), u = !1, d = Ue(n).then(({ width: a, height: o, opaque: s }) => {
			let d = s ? "good" : Ie(m, a, o), f = {
				mode: e.mode,
				grid: m.count,
				bytes: n.size,
				file_type: n.type || "unknown",
				width: a,
				height: o,
				opaque: s,
				read_ms: Date.now() - r
			};
			if ($("photo_picked", f), d === "refused") return u = !0, l.abort(), URL.revokeObjectURL(i), $("photo_refused", {
				...f,
				dpi: Le(m, a, o),
				needed_px: m.minPixels,
				short_by_px: Math.max(0, m.minPixels - Math.min(a, o))
			}), R(t, {
				status: "refused",
				fileName: n.name,
				width: a,
				height: o
			}), null;
			let p = d === "soft";
			return p && $("photo_soft", {
				...f,
				dpi: Le(m, a, o)
			}), c = {
				fileName: n.name,
				objectUrl: i,
				width: a,
				height: o,
				soft: p
			}, {
				width: a,
				height: o,
				photo: f
			};
		});
		d.catch(() => void 0);
		let f = Date.now();
		try {
			let i = await o;
			if (u) return;
			R(t, {
				...c,
				status: "uploading",
				progress: 0
			}), f = Date.now();
			let a = await St(n, {
				apiUrl: e.apiUrl,
				token: i,
				signal: l.signal,
				onProgress: (e) => {
					u || R(t, {
						...c,
						status: "uploading",
						progress: e
					});
				}
			}), p = await d;
			if (!p) return;
			$("upload_ok", {
				...p.photo,
				ms: Date.now() - f,
				verify_ms: s,
				total_ms: Date.now() - r
			}), R(t, {
				...c,
				status: "ready",
				key: a.key,
				crop: We(p.width || 1, p.height || 1)
			});
		} catch (i) {
			if (u) return;
			$("upload_failed", {
				...(await d.catch(() => null))?.photo ?? {
					mode: e.mode,
					grid: m.count,
					bytes: n.size,
					file_type: n.type || "unknown"
				},
				ms: Date.now() - f,
				verify_ms: s,
				total_ms: Date.now() - r,
				reason: i instanceof Z ? i.code : "unknown",
				retryable: i instanceof Z && i.retryable
			}), R(t, {
				...c,
				status: "failed",
				message: i instanceof Z ? i.message : "That photo didn't upload. Try again in a moment."
			});
		}
	}
	let oe = (e, t) => {
		if (!e?.length) return;
		S(null), w(!1);
		let n = [t];
		for (let r = 0; r < h.length && n.length < e.length; r++) r !== t && h[r]?.status === "empty" && n.push(r);
		n.forEach((t, n) => {
			let r = e[n];
			r && ae(t, r);
		});
	}, se = () => {
		g(Et(m.photos)), w(!1);
	}, ce = h.findIndex((e) => e.status === "empty" || e.status === "refused"), z = h.filter((e) => e.status === "ready"), B = z.length === m.photos, V = m.photos - z.length, le = h.some((e) => e.status === "uploading");
	G(() => {
		$("builder_ready", {
			mode: e.mode,
			grid: m.count,
			photos: m.photos
		});
	}, [
		e.mode,
		m.count,
		m.photos
	]);
	let H = K(!1);
	G(() => {
		if (!B) {
			H.current = !1;
			return;
		}
		H.current || (H.current = !0, $("set_complete", {
			mode: e.mode,
			grid: m.count,
			quantity: t ? c : 1,
			booth: !!A
		}));
	}, [
		B,
		e.mode,
		m.count,
		t,
		c,
		A
	]);
	async function ue(n) {
		if (!(!B || !d)) {
			b(!0), S(null);
			try {
				let r = await St(await Ye(e.mode, m, z), {
					apiUrl: e.apiUrl,
					token: await L.current.token()
				});
				if (A) {
					let { code: e } = await mt({
						token: A,
						variantId: d.id,
						slots: z,
						previewUrl: r.url,
						customerName: n?.name || void 0,
						customerEmail: n?.email || void 0,
						customerPhone: n?.phone || void 0,
						customerSubscribe: n?.subscribe || void 0
					});
					F(n?.name ?? ""), N(e), I(!1), w(!0);
					return;
				}
				let i = await ot({
					variantId: d.id,
					slots: z,
					previewUrl: r.url,
					quantity: t ? c : 1,
					...p ? { upgrade: p } : {}
				}, "keepset-personalizer");
				i.totalCents !== null && (D(i.totalCents), e.freeShippingCents && k(!0)), w(!0);
			} catch (n) {
				if ($("submit_failed", {
					mode: e.mode,
					grid: m.count,
					quantity: t ? c : 1,
					booth: !!A,
					reason: n instanceof ut ? "booth_closed" : n instanceof Z ? `preview_${n.code}` : n instanceof rt ? "cart" : n instanceof dt ? "booth" : "unknown"
				}), n instanceof ut) {
					pt(), j(null), S(n.message);
					return;
				}
				S(n instanceof rt || n instanceof dt || n instanceof Z ? n.message : A ? "Something went wrong sending that to the booth. Try again." : "Something went wrong adding that to your cart. Try again.");
			} finally {
				b(!1);
			}
		}
	}
	let U = _ === null ? null : h[_];
	return /* @__PURE__ */ Y("div", {
		class: "ks-pz",
		children: [
			/* @__PURE__ */ Y("div", {
				class: "ks-pz__stage",
				children: [/* @__PURE__ */ Y(nt, {
					mode: e.mode,
					spec: m,
					slots: h,
					activeIndex: _,
					nextIndex: ce,
					onAdjust: re,
					onPick: te
				}), /* @__PURE__ */ Y("p", {
					class: "ks-pz__stage-note",
					children: e.mode === "mosaic" ? `One photo across ${m.count} magnets — ${m.inches}in square finished.` : t ? `One photo, ${c} magnets, 2.5in square each.` : `${m.count} ${m.count === 1 ? "magnet" : "magnets"}, 2.5in square each.`
				})]
			}),
			/* @__PURE__ */ Y("div", {
				class: "ks-pz__controls",
				children: [
					t ? /* @__PURE__ */ Y(Tt, {
						tiers: a,
						active: d,
						quantity: c,
						onQuantity: l,
						floor: o,
						ceiling: s,
						currency: e.currency ?? "USD"
					}) : /* @__PURE__ */ Y("fieldset", {
						class: "ks-pz__sizes",
						children: [/* @__PURE__ */ Y("legend", {
							class: "ks-eyebrow",
							children: e.mode === "mosaic" ? "Size" : "How many"
						}), /* @__PURE__ */ Y("div", {
							class: "ks-pz__size-row",
							children: e.variants.map((t) => /* @__PURE__ */ Y("label", {
								class: `ks-pz__size${t.id === r ? " is-selected" : ""}${t.available ? "" : " is-unavailable"}`,
								children: [
									/* @__PURE__ */ Y("input", {
										type: "radio",
										name: "ks-size",
										value: t.id,
										checked: t.id === r,
										disabled: !t.available,
										onChange: () => ie(t.id)
									}),
									/* @__PURE__ */ Y("span", {
										class: "ks-pz__size-count",
										children: t.count
									}),
									/* @__PURE__ */ Y("span", {
										class: "ks-pz__size-price",
										children: t.price
									}),
									Ot(t, e.currency ?? "USD") && /* @__PURE__ */ Y("span", {
										class: "ks-pz__size-each",
										children: [Ot(t, e.currency ?? "USD"), " each"]
									})
								]
							}, t.id))
						})]
					}),
					!t && !!e.freeShippingCents && typeof d?.priceCents == "number" && /* @__PURE__ */ Y(kt, {
						cartCents: E,
						setCents: d.priceCents,
						threshold: e.freeShippingCents,
						currency: e.currency ?? "USD"
					}),
					/* @__PURE__ */ Y("div", {
						class: "ks-pz__photos",
						children: [
							/* @__PURE__ */ Y("p", {
								class: "ks-eyebrow",
								children: m.photos === 1 ? "Your photo" : "Your photos"
							}),
							z.length === 0 && !le && /* @__PURE__ */ Y("p", {
								class: "ks-pz__photos-hint",
								children: m.photos === 1 ? "Tap the square below to choose a photo from your phone." : `Tap a square below to choose a photo from your phone — you can pick all ${m.photos} at once.`
							}),
							/* @__PURE__ */ Y("div", {
								class: "ks-pz__strip",
								style: { "--ks-pz-columns": Math.min(Math.max(m.photos, 4), 5) },
								children: h.map((e, t) => /* @__PURE__ */ Y(Nt, {
									index: t,
									slot: e,
									spec: m,
									isNext: t === ce,
									onPick: (e) => oe(e, t),
									onCrop: () => re(t),
									onClear: () => R(t, { status: "empty" })
								}, t))
							})
						]
					}),
					x && /* @__PURE__ */ Y("p", {
						class: "ks-pz__error",
						role: "alert",
						children: x
					}),
					C && M ? /* @__PURE__ */ Y("div", {
						class: "ks-pz__done ks-pz__booth",
						role: "status",
						children: [
							/* @__PURE__ */ Y("p", {
								class: "ks-pz__booth-label",
								children: P.trim() ? `Thanks, ${P.trim().split(/\s+/)[0]}` : "Show us this"
							}),
							/* @__PURE__ */ Y("p", {
								class: "ks-pz__booth-code",
								children: M
							}),
							/* @__PURE__ */ Y("p", {
								class: "ks-pz__done-text",
								children: "We'll make it now. Keep this screen — it's how we find your order."
							}),
							/* @__PURE__ */ Y("a", {
								class: "ks-pz__again",
								href: Dt,
								children: "Make another — you’ll get a new code"
							})
						]
					}) : C ? /* @__PURE__ */ Y("div", {
						class: "ks-pz__done",
						role: "status",
						children: [
							/* @__PURE__ */ Y("p", {
								class: "ks-pz__done-text",
								children: "Added to your cart."
							}),
							!!e.freeShippingCents && /* @__PURE__ */ Y(jt, {
								totalCents: E,
								threshold: e.freeShippingCents,
								currency: e.currency ?? "USD"
							}),
							/* @__PURE__ */ Y("button", {
								type: "button",
								class: "ks-btn ks-btn--primary ks-pz__submit",
								onClick: se,
								children: "Build another"
							}),
							/* @__PURE__ */ Y("a", {
								class: "ks-pz__again",
								href: "/cart",
								children: "Go to cart"
							})
						]
					}) : /* @__PURE__ */ Y(T, { children: /* @__PURE__ */ Y("button", {
						type: "button",
						class: `ks-btn ks-btn--primary ks-pz__submit${B && !y ? " is-ready" : ""}`,
						disabled: !B || y,
						onClick: () => A ? I(!0) : void ue(),
						children: y ? A ? "Sending…" : "Adding…" : B ? A ? "Pay at the table" : `Add to cart — ${(t ? f : d?.price) ?? ""}` : le ? "Just a moment…" : `Add ${V} ${V === 1 ? "photo" : "photos"}`
					}) })
				]
			}),
			ee && /* @__PURE__ */ Y(ht, {
				busy: y,
				onSubmit: (e) => void ue(e),
				onCancel: () => I(!1)
			}),
			O && !!e.freeShippingCents && /* @__PURE__ */ Y(At, {
				totalCents: E,
				threshold: e.freeShippingCents,
				currency: e.currency ?? "USD",
				onClose: () => k(!1),
				onBuildAnother: se
			}),
			U && U.status === "ready" && _ !== null && /* @__PURE__ */ Y("div", {
				class: "ks-pz__modal",
				role: "dialog",
				"aria-modal": "true",
				"aria-label": "Adjust the crop",
				children: /* @__PURE__ */ Y(Be, {
					src: U.objectUrl,
					width: U.width || 1,
					height: U.height || 1,
					crop: U.crop,
					spec: m,
					onChange: (e) => R(_, {
						...U,
						crop: e
					}),
					onDone: () => v(null),
					onCancel: () => {
						let e = ne.current ?? We(U.width || 1, U.height || 1);
						R(_, {
							...U,
							crop: e
						}), v(null);
					}
				})
			})
		]
	});
}
function Nt({ index: e, slot: t, spec: n, isNext: r, onPick: i, onCrop: a, onClear: o }) {
	let s = `ks-pz-file-${e}`;
	return t.status === "empty" || t.status === "refused" ? /* @__PURE__ */ Y("div", {
		class: `ks-pz__chip${t.status === "refused" ? " is-refused" : ""}${r ? " is-next" : ""}`,
		children: [/* @__PURE__ */ Y("label", {
			class: "ks-pz__drop",
			for: s,
			children: [
				/* @__PURE__ */ Y("span", {
					class: "ks-pz__plus",
					"aria-hidden": "true",
					children: "+"
				}),
				/* @__PURE__ */ Y("span", {
					class: "ks-visually-hidden",
					children: ["Add photo ", e + 1]
				}),
				t.status === "refused" && /* @__PURE__ */ Y("span", {
					class: "ks-pz__chip-note",
					children: [
						"Too small — ",
						Le(n, t.width, t.height),
						" dpi"
					]
				})
			]
		}), /* @__PURE__ */ Y("input", {
			id: s,
			class: "ks-visually-hidden",
			type: "file",
			accept: "image/jpeg,image/png,image/webp,image/heic,image/heif",
			multiple: !0,
			onChange: (e) => {
				let t = e.currentTarget;
				i(t.files), t.value = "";
			}
		})]
	}) : /* @__PURE__ */ Y("div", {
		class: `ks-pz__chip is-filled${t.status === "failed" ? " is-failed" : ""}`,
		children: [
			/* @__PURE__ */ Y("div", {
				class: "ks-pz__chip-frame",
				children: /* @__PURE__ */ Y("img", {
					class: "ks-pz__chip-thumb",
					src: t.objectUrl,
					alt: t.fileName,
					style: t.status === "ready" ? Ve(J(t.crop, n)) : void 0
				})
			}),
			t.status === "uploading" && /* @__PURE__ */ Y(Ze, {
				progress: t.progress,
				label: t.fileName,
				indeterminate: t.verifying
			}),
			t.status === "uploading" && t.verifying && /* @__PURE__ */ Y("p", {
				class: "ks-pz__chip-note",
				children: "Checking…"
			}),
			t.status === "failed" && /* @__PURE__ */ Y("p", {
				class: "ks-pz__chip-note is-error",
				children: t.message
			}),
			t.status === "ready" && t.soft && /* @__PURE__ */ Y("p", {
				class: "ks-pz__chip-note",
				title: `${t.width}×${t.height}px`,
				children: "A little soft"
			}),
			(t.status === "ready" || t.status === "failed") && /* @__PURE__ */ Y("div", {
				class: "ks-pz__chip-actions",
				children: [t.status === "ready" && /* @__PURE__ */ Y("button", {
					type: "button",
					onClick: a,
					"aria-label": "Adjust this photo",
					children: "Adjust"
				}), /* @__PURE__ */ Y("button", {
					type: "button",
					onClick: o,
					"aria-label": "Remove this photo",
					children: "✕"
				})]
			})
		]
	});
}
//#endregion
//#region src/personalizer/main.tsx
var Pt = [
	"127.0.0.1",
	"localhost",
	"::1",
	"[::1]"
], Ft = "http://127.0.0.1:8787", It = "1x00000000000000000000AA";
function Lt(e) {
	return Pt.includes(window.location.hostname) ? (console.info("[keepset] localhost — uploading to %s with Turnstile test keys. Start it with `cd api && npm run dev` if uploads cannot connect.", Ft), {
		...e,
		apiUrl: Ft,
		turnstileSitekey: It
	}) : e;
}
function Rt(e) {
	let t = e.dataset.config;
	if (!t) return;
	let n;
	try {
		n = JSON.parse(t);
	} catch {
		console.error("[keepset] personalizer config could not be parsed");
		return;
	}
	if (!n.variants?.length) {
		console.error("[keepset] personalizer has no variants to offer");
		return;
	}
	e.innerHTML = "", ce(/* @__PURE__ */ Y(Mt, { config: Lt(n) }), e);
}
for (let e of document.querySelectorAll("[data-keepset-personalizer]")) Rt(e);
document.addEventListener("shopify:section:load", (e) => {
	let t = e.target?.querySelector("[data-keepset-personalizer]");
	t && Rt(t);
});
//#endregion
